import React, {useState, useEffect, useRef} from 'react';
import throttle from 'lodash/throttle';
import PropTypes from 'prop-types';
import {button, primary} from 'src/styles/modules/button.module.scss';
import {inputCard, textInput, column, selectColumn, filterColumn} from './styles.module.scss';
import {ADDRESS_INPUT_LIMIT} from 'src/pages/localChannelLineup/constants/addressInputLimit';
import {ASC, DESC} from 'src/pages/localChannelLineup/constants/lineupOrder';
import {input, select, selectWrap, filterWrap} from 'src/styles/modules/forms.module.scss';
import Autosuggest from 'react-autosuggest';
import theme from './autosuggest.module.scss';

export const AddressInput = ({
  address,
  channelsLoaded,
  clearLocationSuggestions,
  filter,
  isAuth,
  lineupOrder,
  loadChannels,
  loadLocationSuggestions,
  setAddress,
  setFilter,
  setLineupOrder,
  signInUrl,
  suggestions,
}) => {
  const throttleFilter = useRef(throttle(setFilter, 250));
  const [localFilter, setLocalFilter] = useState(filter);

  useEffect(() => {
    throttleFilter.current(localFilter);
  }, [localFilter]);

  const throttleLoadLocations = useRef(throttle(loadLocationSuggestions, 1000));
  const [lastValue, setLastValue] = useState(address);
  const onSuggestionsFetchRequested = ({value}) => {
    if (value !== lastValue && value.trim().length > ADDRESS_INPUT_LIMIT) {
      throttleLoadLocations.current(value);
      setLastValue(value);
    }
  };

  const handleChannels = e => {
    e.preventDefault;
    loadChannels();
  };

  return (
    <>
      <div className={inputCard}>
        <div className={column}>
          <Autosuggest
            getSuggestionValue={suggestion => suggestion}
            onSuggestionsClearRequested={clearLocationSuggestions}
            onSuggestionsFetchRequested={onSuggestionsFetchRequested}
            onSuggestionSelected={handleChannels}
            renderSuggestion={suggestion => <span>{suggestion}</span>}
            suggestions={suggestions}
            theme={theme}
            inputProps={{
              className: `${input} ${textInput}`,
              onChange: (event, {newValue}) => setAddress(newValue),
              placeholder: 'Enter your street address and ZIP code',
              type: 'text',
              value: address,
              name: 'address',
              id: 'address',
              'aria-required': true,
            }}
          />
        </div>
        <div className={column}>
          <button
            type="button"
            className={`${button} ${primary}`}
            onClick={handleChannels}
          >
            Find Address
          </button>
        </div>
        {!isAuth && <div className={column}><p><a href={signInUrl}>Sign in to view your channels</a></p></div>}
      </div>
      {
        channelsLoaded &&
        <div className={inputCard}>
          <div className={`${column} ${selectColumn}`}>
            <div className={selectWrap}>
              <select
                className={`${input} ${select}`}
                onChange={e => setLineupOrder(e.target.value)}
                onBlur={e => setLineupOrder(e.target.value)}
                value={lineupOrder}
                name="lineupOrder"
                id="lineupOrder"
              >
                <option value={ASC}>Channel Number: Ascending</option>
                <option value={DESC}>Channel Number: Descending</option>
              </select>
            </div>
          </div>
          <div className={`${column} ${filterColumn}`}>
            <div className={filterWrap}>
              <input
                className={input}
                id="channelFilter"
                name="channelFilter"
                onChange={event => setLocalFilter(event.target.value)}
                placeholder="Channel Name (e.g., HBO, Starz, etc.)"
                type="text"
                value={localFilter}
              />
            </div>
          </div>
        </div>
      }
    </>
  );
};

AddressInput.propTypes = {
  address: PropTypes.string.isRequired,
  channelsLoaded: PropTypes.bool.isRequired,
  clearLocationSuggestions: PropTypes.func.isRequired,
  filter: PropTypes.string.isRequired,
  isAuth: PropTypes.bool.isRequired,
  lineupOrder: PropTypes.string.isRequired,
  loadChannels: PropTypes.func.isRequired,
  loadLocationSuggestions: PropTypes.func.isRequired,
  setAddress: PropTypes.func.isRequired,
  setFilter: PropTypes.func.isRequired,
  setLineupOrder: PropTypes.func.isRequired,
  signInUrl: PropTypes.string,
  suggestions: PropTypes.arrayOf(PropTypes.string).isRequired,
};
